import React, {useContext, useEffect, useRef, useState} from "react";
import {Button, Form, Input, InputNumber, Popconfirm, Table} from "antd";
import type {FormInstance} from "antd/es/form";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {setSelectedMedicinesExport} from "redux/reducer/pharmacyStore";
import {FIELD_TYPE} from "types/enums";
const {INPUT, CURRENCY, NUMBER} = FIELD_TYPE;
const EditableContext = React.createContext<FormInstance<any> | null>(null);
interface EditableRowProps {
  index: number;
}
interface EditableCellProps {
  title: React.ReactNode;
  editable: boolean;
  children: React.ReactNode;
  dataIndex: string;
  record: any;
  type?: any;
  handleSave: (record: any) => void;
}
const EditableRow: React.FC<EditableRowProps> = ({index, ...props}) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell: React.FC<EditableCellProps> = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  type,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef<any>(null);
  const form = useContext(EditableContext)!;
  const dispatch = useAppDispatch();
  const selectedMedicinesExport = useAppSelector(
    state => state.pharmacyStore.selectedMedicinesExport
  );

  useEffect(() => {
    if (editing) {
      inputRef?.current?.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({[dataIndex]: record[dataIndex]});
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      const newRecord = {...record, ...values};
      handleSave(newRecord);
      editSelectedMedicinesExport(newRecord);
    } catch (errInfo) {}
  };
  const editSelectedMedicinesExport = newRecord => {
    const newSelectedMedicinesExport = [...selectedMedicinesExport];
    let index = newSelectedMedicinesExport.findIndex(e => e.id == newRecord.id);
    const oldRecord = newSelectedMedicinesExport[index];
    newSelectedMedicinesExport.splice(index, 1, {...oldRecord, ...newRecord});
    dispatch(setSelectedMedicinesExport(newSelectedMedicinesExport));
  };

  const validateMaxValue = (_, value) => {
    if (value <= record["tonKho"]) {
      return Promise.resolve();
    } else {
      return Promise.reject();
    }
  };
  const checkValueInt = (_, value) => {
    if ((!value && value !== 0) || value < 0) {
      return Promise.reject();
    } else {
      return Promise.resolve();
    }
  };
  let childNode = children;
  let childNodeEditing = null;
  if (type == CURRENCY) {
    childNodeEditing = (
      <Form.Item
        style={{margin: 0}}
        name={dataIndex}
        initialValue={record ? record[dataIndex] : null}
      >
        <InputNumber
          ref={inputRef}
          defaultValue={record[dataIndex]}
          formatter={value =>
            `${Math.round(value)?.toString()}`.replace(
              /\B(?=(\d{3})+(?!\d))/g,
              ","
            )
          }
          parser={value => value!.replace(/\$\s?|(,*)/g, "")}
          onPressEnter={() => {
            inputRef?.current!.blur();
          }}
          onBlur={e => {
            e.preventDefault();
            save();
          }}
          placeholder={"Nhập"}
          // addonAfter="VNĐ"
          stringMode
          controls={false}
          min={0}
          {...restProps}
        />
      </Form.Item>
    );
  }
  if (type == INPUT) {
    childNodeEditing = (
      <Form.Item
        style={{margin: 0}}
        name={dataIndex}
        initialValue={record[dataIndex]}
      >
        <Input
          // defaultValue={dataIndex === 'nhanVienLayMau' ? localStorage.getItem("username") : ""}
          onPressEnter={() => {
            inputRef?.current!.blur();
          }}
          ref={inputRef}
          onBlur={e => {
            e.preventDefault();
            save();
          }}
          style={{
            padding: "4px",
            border: "1px solid #EBEBF0",
            borderRadius: "4px",
          }}
        />
      </Form.Item>
    );
  }
  if (type == NUMBER) {
    childNodeEditing = (
      <Form.Item
        style={{margin: 0}}
        name={dataIndex}
        rules={[
          {
            validator: validateMaxValue,
            message: `Đã vượt qua số lượng tồn kho`,
          },
          {
            validator: checkValueInt,
            message: `Số lượng phải lớn hơn 0`,
          },
        ]}
      >
        <InputNumber
          ref={inputRef}
          onPressEnter={() => {
            inputRef?.current!.blur();
          }}
          onBlur={e => {
            e.preventDefault();
            save();
          }}
        />
      </Form.Item>
    );
  }
  if (editable) {
    childNode = editing ? (
      childNodeEditing
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          minHeight: 22,
        }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};

const components = {
  body: {
    row: EditableRow,
    cell: EditableCell,
  },
};

export {EditableCell, EditableRow, components};
